$(".statistics-bar").each(function () {
    var titleColor = $(this).data("title-color"),
        backgroundColor = $(this).data("background-color");
    $(this).css({ 'background-color': backgroundColor});
    $(this).find('.statistics-bar__box__title').css('color', titleColor);
});